module.exports = __webpack_public_path__ + "img/content04.c2246c78.svg";